import dayjs from 'dayjs';
import { DatePicker } from 'antd';
import bladeStyles from './Blade.module.css';
import { isBladeMonthEditable } from '@utils/effectiveMonthYear';

interface MeterInfoSectionProps {
  meterName?: string | null;
  meterNumber?: string | null;
  monthLabel: string;
  monthYear?: string;
  onMonthChange?: (monthYear: string) => void;
}

const MeterInfoSection = ({ meterName, meterNumber, monthLabel, monthYear, onMonthChange }: MeterInfoSectionProps) => {
  const editable = isBladeMonthEditable();
  // eslint-disable-next-line no-console
  console.log('[MeterInfoSection] isBladeMonthEditable:', editable, '| monthYear:', monthYear, '| onMonthChange provided:', !!onMonthChange, '| will show picker:', editable && !!onMonthChange && !!monthYear);
  return (
  <div className={bladeStyles.section}>
    <div className={bladeStyles.meterInfo}>
      <div>
        <div className={bladeStyles.fieldLabel}>Meter Name</div>
        <div className={bladeStyles.fieldValue} data-testid="blade-meter-name">{meterName ?? '—'}</div>
      </div>
      <div>
        <div className={bladeStyles.fieldLabel}>Meter ID</div>
        <div className={bladeStyles.fieldValue} data-testid="blade-meter-number">{meterNumber ?? '—'}</div>
      </div>
      <div>
        <div className={bladeStyles.fieldLabel}>Month</div>
        {isBladeMonthEditable() && onMonthChange && monthYear ? (
          <DatePicker
            picker="month"
            value={dayjs(monthYear, 'YYYY-MM')}
            format="MMM YYYY"
            allowClear={false}
            size="small"
            onChange={(date) => { if (date) onMonthChange(date.format('YYYY-MM')); }}
            style={{ fontWeight: 600 }}
            getPopupContainer={(trigger) => trigger.closest('.blade-panel') as HTMLElement || document.body}
            data-testid="blade-month-picker"
          />
        ) : (
          <div className={bladeStyles.fieldValue} data-testid="blade-month">{monthLabel}</div>
        )}
      </div>
    </div>
  </div>
  );
};

export default MeterInfoSection;
